export const getClientDetailsSteps = (t) => [
    {
        target: 'body',
        placement: 'center',
        title: t('tour.clientDetails.step-welcome-title'),
        content: t('tour.clientDetails.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cd-profile"]',
        title: t('tour.clientDetails.step-profile-title'),
        content: t('tour.clientDetails.step-profile-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cd-actions"]',
        title: t('tour.clientDetails.step-actions-title'),
        content: t('tour.clientDetails.step-actions-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cd-diet"]',
        title: t('tour.clientDetails.step-diet-title'),
        content: t('tour.clientDetails.step-diet-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cd-exams"]',
        title: t('tour.clientDetails.step-exams-title'),
        content: t('tour.clientDetails.step-exams-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cd-charts"]',
        title: t('tour.clientDetails.step-charts-title'),
        content: t('tour.clientDetails.step-charts-content'),
        disableBeacon: true,
    },
];
